module.exports = __webpack_public_path__ + "static/media/Panier3.1ad0e4fa.jpeg";